import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducer';
import api from './Middleware/api';

const store = configureStore({ 
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api),
});

export default store;